// Import Components
import InfiniteWall from 'components/InfiniteWall';
import MediaContainer from 'components/MediaContainer';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
// Import styles
import styles from './style.scss';

/**
 * Channel component
 */
@inject('MediahubStore', 'ViewStore')
@observer
class Channel extends Component {
  render() {
    const { MediahubStore, ViewStore } = this.props;

    return (
      <div ref={(ref) => this._container = ref} className={styles.container} >
        {/* InfiniteWall */}
        <InfiniteWall
          items={MediahubStore.mediaContainers}
          itemsCount={_.size(MediahubStore.mediaContainers)}
          itemsRenderer={MediaContainer} />
        {/* InfiniteWall */}
      </div >
    );
  }
}

export default Channel;



// WEBPACK FOOTER //
// ./src/containers/Channel/index.js